import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text_btns" }
const _hoisted_2 = { class: "operation-wrapper" }

import { computed, onMounted, Ref, ref, watch } from 'vue'

/********************************
 ********** COMPONENTES *********
 *******************************/
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';
import AdminDialog from '@/components/RAOS/Dialogs/AdminDialog.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { HEADER } from '@/interfaces/SmartLink/Tables';


/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useDisplay } from 'vuetify';

export default /*@__PURE__*/_defineComponent({
  __name: 'AdminUser',
  setup(__props) {

const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 *********** VUETIFY ************
 *******************************/
const {xs, md,smAndDown } = useDisplay();


const headers = computed<HEADER[]>(() => [
    { text:  t('labels.name'), value: "nombre", sortable: true },
    { text:  t('labels.assigned'), value: "asignado", sortable: true },
    { text:  t('labels.turn'), value: "turno", sortable: true },
    { text:  t('labels.operation'), value: "operation", sortable: false},
])


/**
 * Sirve para buscar según que columnas, si no hay puesta ninguna, se busca en todas
 */
const searchField           = ref();


/**
 * Busca dentro de la tabla el valor que se escribe aquí
 */
const searchValue           = ref("");


/**
 * Ancho del dialogo, dependiendo del dispositivo donde se ve
 */
const width                 = computed(() => md.value?'60%':smAndDown.value?'85%':'900px');

/**
 * Mostrar el Dialogo
 */
const dialog                = ref(false);

const items   = computed(()=>store.state.arrayUserInfo);
// const showTable = ref(false)
/**
 * Objeto que inicializa el dialog al seleccionar alguna fila de la tabla
 */
const objectItem   = ref<any>({
    id      : 0,
    nombre : '',
    asignado : '',
    turno : '',
})


/**
 * Darle click al boton AGREGAR, abrira el dialog y agregara al objeto
 * "objectItem", el tipo de dialogo, en este caso: 'ADD'
 */
const showAddDialog     = () => { 
    objectItem.value['typeDialog']  = 'add';
    dialog.value                    = true;
}

/**
 * Darle click al boton EDITAR (lapiz), abrira el dialog 
 * Reemplaza el objeto "objectItem" con los valores de la fila seleccionada
 * y tambien agrega el tipo de dialogo, en este caso: 'EDIT'. 
 */
const showEditDialog    = (item:any) => {
    objectItem.value                = item ;
    objectItem.value['typeDialog']  = 'edit';
    dialog.value                    = true;
}

/**
 * Darle click al boton BORRAR (tacho), abrira el dialog 
 * Reemplaza el objeto "objectItem" con los valores de la fila seleccionada
 * y tambien agrega el tipo de dialogo, en este caso: 'DELETE'. 
 */
const showDeleDialog    = (item:any) => { 
    objectItem.value                = item ;
    objectItem.value['typeDialog']  = 'delete';
    dialog.value                    = true;
}

/**
 * Cierra el Diálogo cambiando el valor del dialog a FALSE
 */
const closeDialog       = () => {
    dialog.value    = false; 
}

function resetUser () {
    objectItem.value = {
        id : 0,
        nombre : '',
        asignado : '',
        turno : '',
    }
}

watch(dialog, (isOpen) => {
    !isOpen ? resetUser() : null;
})

onMounted(async () => {
    
    // headers.value = HEADERS_ADMIN['header']
    await store.dispatch('getAllUsers');
})


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (items.value.length > 0)
    ? (_openBlock(), _createBlock(_component_v_sheet, {
        key: 0,
        color: "bgtopology",
        class: "adminview ma-4 pa-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            justify: "space-between",
            class: "pb-6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "px-6",
                cols: "12",
                sm: "4",
                md: "3",
                lg: "3",
                xl: "2",
                "align-self": "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    block: "",
                    color: "success",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showAddDialog()))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('buttons.add')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                class: "ma-0",
                justify: "end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    class: "px-6 pt-0",
                    cols: "12",
                    sm: "12",
                    md: "9",
                    lg: "9",
                    xl: "10",
                    "align-self": "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        class: "ma-0",
                        style: {"width":"100%"},
                        justify: "end"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            style: _normalizeStyle(!_unref(xs) ? 'max-width: 400px !important; margin-top: 10px':'padding-top: 10px !important'),
                            modelValue: searchValue.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
                            label: _unref(t)('search'),
                            variant: "outlined",
                            density: "compact",
                            "hide-details": ""
                          }, null, 8, ["style", "modelValue", "label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_dialog, {
            modelValue: dialog.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialog).value = $event)),
            width: width.value
          }, {
            default: _withCtx(() => [
              _createVNode(AdminDialog, {
                itemObject: objectItem.value,
                onCloseDialog: _cache[2] || (_cache[2] = ($event: any) => (closeDialog()))
              }, null, 8, ["itemObject"])
            ]),
            _: 1
          }, 8, ["modelValue", "width"]),
          _createVNode(_component_EasyDataTable, {
            "search-field": searchField.value,
            "search-value": searchValue.value,
            "table-class-name": "customize-table",
            "show-index": "",
            headers: headers.value,
            items: items.value
          }, {
            "item-operation": _withCtx((item) => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_icon, {
                  color: "blue",
                  onClick: ($event: any) => (showEditDialog(item))
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" mdi-pencil-plus ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_icon, {
                  color: "red",
                  onClick: ($event: any) => (showDeleDialog(item))
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" mdi-delete ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          }, 8, ["search-field", "search-value", "headers", "items"])
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_v_sheet, {
        key: 1,
        class: "text-center"
      }, {
        default: _withCtx(() => [
          _createVNode(Prog_circular)
        ]),
        _: 1
      }))
}
}

})